import React from 'react';

import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import IconCatering from 'components/icons/catering';
import IconCoffeeCup from 'components/icons/coffee-cup';
import IconMobileNavLogo from 'components/icons/mobile-nav-home';
import TimsBarcode from 'components/icons/tims-barcode';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import { useUIContext } from 'state/ui';
import { EventName, emitEvent } from 'utils/event-hub';
import { routes } from 'utils/routing';

import { NavLink, iconSize } from './helpers';
import { getAboutLink, getAccountLink } from './nav-links-item';
import { IconWrap, NavLinkText } from './styled';
import { NavButton } from './styled-link';
import { GetNavLinksParams, NavigationMobileTab } from './types';

const BrandLogo = styled(IconMobileNavLogo)<{ viewBox: string }>`
  height: 30px;
`;

const homeTextKey = 'home';
const orderTextKey = 'order';
const cateringTextKey = 'catering';

export const getNavLinks = ({
  enableAccountInFooter,
  menuHref,
  formatMessage,
}: GetNavLinksParams): NavigationMobileTab[] => {
  return [
    {
      selectedHrefs: [routes.base],
      Component: () => (
        <NavLink data-testid="home-mobile" to={routes.base} requiresExactMatch>
          <IconWrap>
            <BrandLogo viewBox="0 0 24 24" />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: homeTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [menuHref],
      Component: () => (
        <NavLink data-testid="order-mobile" to={menuHref}>
          <IconWrap>
            <IconCoffeeCup height={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: orderTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [],
      Component: () => {
        const { showRewardsTab, hideDrawer, isShowingDrawer } = useUIContext();
        const { activeCard } = useLoyaltyActiveCard();
        const navigate = useNavigate();
        const scanTextKey = 'scan';
        const linkText = formatMessage({ id: scanTextKey });

        return (
          <NavButton
            className={isShowingDrawer ? 'active' : ''}
            onClick={() => {
              if (!isShowingDrawer) {
                emitEvent(EventName.BOTTOM_TAB_PRESSED, {
                  route: '/scan',
                });
              }
              if (!activeCard) {
                return navigate(routes.signIn);
              }
              return isShowingDrawer ? hideDrawer() : showRewardsTab();
            }}
          >
            <IconWrap>
              <TimsBarcode width={iconSize} />
            </IconWrap>
            <NavLinkText>{linkText}</NavLinkText>
          </NavButton>
        );
      },
    },
    {
      selectedHrefs: [routes.catering],
      Component: () => (
        <NavLink data-testid="recent-orders-mobile" to={formatMessage({ id: 'routes.catering' })}>
          <IconWrap aria-hidden>
            <IconCatering />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: cateringTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    enableAccountInFooter ? getAccountLink({ formatMessage }) : getAboutLink({ formatMessage }),
  ];
};
